import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseApiPath } from '@/app/common/api/config';
import { ApiResponse } from '@/app/common/types/common';
import customFetchBase from '@/app/common/utils/customFetchBase';
import {
  ExportRelatedKeywordsRequest,
  GetRelatedKeywordsRequest,
  RelatedKeywordsResponse
} from '@/app/KeywordResearch/types/keywordRelatedApiTypes';

const keywordRelatedApi = createApi({
  reducerPath: 'keywordRelatedApi',
  baseQuery: (...args: unknown[]) =>
    customFetchBase(getBaseApiPath(), ...args),
  endpoints: build => ({
    getRelatedKeywords: build.query<
      RelatedKeywordsResponse,
      GetRelatedKeywordsRequest
    >({
      query: (body: GetRelatedKeywordsRequest) => ({
        url: '/keyword_related/v1/get',
        method: 'POST',
        body
      })
    }),
    getRelatedKeywordsFunc: build.mutation<
      RelatedKeywordsResponse,
      GetRelatedKeywordsRequest
    >({
      query: (body: GetRelatedKeywordsRequest) => ({
        url: '/keyword_related/v1/get',
        method: 'POST',
        body
      })
    }),
    exportTable: build.mutation<
      ApiResponse<unknown>,
      ExportRelatedKeywordsRequest
    >({
      query: (body: ExportRelatedKeywordsRequest) => ({
        url: '/keyword_related/v1/export',
        method: 'POST',
        body
      })
    })
  })
});

export const {
  useGetRelatedKeywordsQuery,
  useGetRelatedKeywordsFuncMutation,
  useExportTableMutation
} = keywordRelatedApi;

export default keywordRelatedApi;
